import { render, staticRenderFns } from "./TantoEdit.vue?vue&type=template&id=3e35ac4a&scoped=true&lang=pug&"
import script from "./TantoEdit.vue?vue&type=script&lang=coffee&"
export * from "./TantoEdit.vue?vue&type=script&lang=coffee&"
import style0 from "./TantoEdit.vue?vue&type=style&index=0&id=3e35ac4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35ac4a",
  null
  
)

export default component.exports